// actions/feeActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getFeeStructure = (params) => async (dispatch) => {
  try {
    dispatch({ type: "FEE_REQUEST" });
    const { data } = await api.get("/fees/structure", { params });
    dispatch({ type: "FEE_STRUCTURE_SUCCESS", payload: data.structures });
  } catch (err) {
    dispatch({ type: "FEE_FAIL", payload: err.response?.data?.message });
  }
};

export const collectFee = (feeData) => async (dispatch) => {
  try {
    dispatch({ type: "FEE_REQUEST" });
    await api.post("/fees/pay", feeData);
    dispatch({ type: "COLLECT_FEE_SUCCESS" });
  } catch (err) {
    dispatch({ type: "FEE_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const getStudentFees = (studentId, params) => async (dispatch) => {
  try {
    dispatch({ type: "FEE_REQUEST" });
    const { data } = await api.get(`/fees/student/${studentId}`, { params });
    dispatch({ type: "STUDENT_FEE_SUCCESS", payload: data });
  } catch (err) {
    dispatch({ type: "FEE_FAIL", payload: err.response?.data?.message });
  }
};

export const getPendingFees = (params) => async (dispatch) => {
  try {
    dispatch({ type: "FEE_REQUEST" });
    const { data } = await api.get("/fees/pending", { params });
    dispatch({ type: "PENDING_FEE_SUCCESS", payload: data.pending });
  } catch (err) {
    dispatch({ type: "FEE_FAIL", payload: err.response?.data?.message });
  }
};

export const getFeeReport = (params) => async (dispatch) => {
  try {
    dispatch({ type: "FEE_REQUEST" });
    const { data } = await api.get("/fees/report", { params });
    dispatch({ type: "FEE_REPORT_SUCCESS", payload: data });
  } catch (err) {
    dispatch({ type: "FEE_FAIL", payload: err.response?.data?.message });
  }
};
